module.exports = __webpack_public_path__ + "img/arrow-shape.2f341003.svg";